import { MeditationIcon } from './MeditationIcon';

/**
 * author: Google
 * id B68AA118-B8B5-4A2A-BCA2-A12C8C119319
 * name meditation
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/meditation.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanMeditationIcon = MeditationIcon;
export default HumanMeditationIcon